module.exports = __webpack_public_path__ + "img/celebrations_bg.998f6b98.png";